<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">成绩预测</div>
                </van-col>
            </van-row>
        </div>
        <div class="content">
            <div class="title">
                <div class="title-left">项目</div>
                <div class="title-right">时间</div>
            </div>
            <div class="item">
                <div class="bar bar1"></div>
                <div class="item-title">5K</div>
                <div class="item-value">{{SwitchTime(forecast.forecast5Latest)}}</div>
            </div>
            <div class="item">
                <div class="bar bar2"></div>
                <div class="item-title">10K</div>
                <div class="item-value">{{SwitchTime(forecast.forecast10Latest)}}</div>
            </div>
            <div class="item">
                <div class="bar bar3"></div>
                <div class="item-title">半马</div>
                <div class="item-value">{{SwitchTime(forecast.forecastHalfLatest)}}</div>
            </div>
            <div class="item last-item">
                <div class="bar bar4"></div>
                <div class="item-title">全马</div>
                <div class="item-value">{{SwitchTime(forecast.forecastMarathonLatest)}}</div>
            </div>
        </div>
        <div class="prop-box">
            <div class="prop-title">
                <img class="prop-icon" src="@/assets/share/forecast/prop.png">
                <div class="prop-text">跑步成绩预测</div>
            </div>
            <div class="prop-content">基于用户的体能等级状态，来预估个人在不同距离跑步时能够达到的最佳成绩，监测您在较长时间内跑步成绩提高的情况。</div>
        </div>
    </div>
</template>

<script>
    import {SwitchTime} from "../../utils/dateUtils";

    export default {
        name: 'forecast',
        data() {
            return {
                sharerId: localStorage.getItem('sharerId'),
                forecast: {}
            }
        },
        mounted() {
            this.getForecast();
        },
        methods: {
            back() {
                this.$router.back();
            },
            getForecast() {
                this.$api.share.friendForecast({
                    sharerId: this.sharerId
                }).then(res => {
                    this.forecast = res.info;
                })
            },
            SwitchTime(t) {
                return SwitchTime(t)
            }
        }
    }
</script>

<style scoped>

    .content {
        width: 345px;
        margin: 15px auto 20px;
        background: #202020;
        border-radius: 6px;
    }

    .title {
        width: 345px;
        height: 30px;
        background: #404040;
        border-radius: 6px 6px 6px 6px;
        position: relative;
    }

    .title-left {
        position: absolute;
        font-size: 12px;
        left: 44px;
        top: 7px;
        color: #B2B2B2;
        opacity: 1;
    }

    .title-right {
        position: absolute;
        font-size: 12px;
        right: 56px;
        top: 7px;
        color: #B2B2B2;
        opacity: 1;
    }

    .item {
        height: 40px;
        width: 295px;
        margin: 0 auto;
        border-bottom: 1px solid #404040;
        position: relative;
    }

    .bar {
        width: 8px;
        height: 8px;
        position: absolute;
        top: 16px;
        left: 0;
        border-radius: 50%;
    }

    .bar1 {
        background: #20D38F;
    }

    .bar2 {
        background: #55A2F2;
    }

    .bar3 {
        background: #FEDB2D;
    }

    .bar4 {
        background: #E24160;
    }

    .item-title {
        position: absolute;
        top: 12px;
        left: 23px;
        font-size: 12px;
    }

    .item-value {
        font-family: SemiBold;
        font-size: 17px;
        position: absolute;
        top: 10px;
        right: 19px;
    }

    .last-item {
        border: none;
    }

    .prop-box {
        width: 345px;
        height: 121px;
        background: #202020;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        margin: 0 auto;
    }

    .prop-title {
        border-bottom: 1px solid #000000;
    }

    .prop-icon {
        width: 16px;
        margin-left: 15px;
    }

    .prop-text {
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
    }

    .prop-content {
        margin: 15px 10px 0px 38px;
        font-size: 12px;
        color: #A5A5A5;
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/forecast.vue